import React from 'react';
import { Card } from './Card';
import { LineChart } from '../charts/LineChart';
import { OccupancyIcon } from '../icons/OccupancyIcon';
import { Information } from '../Information';

const OccupancyCard = ({ total, title, color, informationId }: Props) => {
  let c = '#FF772C';
  if(color === 'info') {
    c = '#00CFE8';
  }
  else if(color === 'purple') {
    c = '#A162F7';
  }
  const datasets = [{ data: [ 100,  300, 200, 150 ], color: c, fill: 'start', label: '' }];
  const labels = ['a', 'b', 'c', 'd' ];
  return (
    <Card className={`card-border-shadow-${color}`}>
       <div className="card-body p-0">
        <div className="row h-100">
          <div className="d-flex ms-3 mt-4">
            <OccupancyIcon size="sm" color={color} />
            <h4 className="ms-3 mb-2">{total}</h4>
          </div>
          <div className="col-12 ms-3">
            <div className="d-flex align-items-center">
              <Information id={informationId} content={<span>{title}</span>} />
              <Information id={informationId} showMore={true} className="ms-2" />
            </div>
          </div>
          <div className="col-12 p-0 m-0">
            <LineChart datasets={datasets} labels={labels} displayAxes={false} height={140} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  total: number,
  title: string,
  color: 'info' | 'orange' | 'purple',
  informationId: string
}

export { OccupancyCard };